import { BaseDTO } from '../../../../utils/base.dto';
import { OfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';
import { ReportOrderSalesBySupplierType } from '../../../reports/report-sales-by-supplier/reportOrderSalesBySupplier.types';
import {
  BrandSplitSettings,
  ListOrdersDTO,
  Order,
  OrderListWithBaseItem,
  StatusType,
  SynchronizedType,
} from '../../order.types';
import { ActionEnum } from './orderActions.types';

export class OrderActionProps extends BaseDTO<OrderActionProps> {
  orderId?: string;

  orderCode?: string;

  brandId?: string;

  brandCommercialName?: string;

  brandCompanyName?: string;

  customerId?: string;

  customerCommercialName?: string;

  customerCompanyName?: string;

  orderSplitSettings?: BrandSplitSettings[];

  orderSplitted?: boolean;

  orderStatus?: StatusType | OfflineStatus;

  orderSyncStatus?: SynchronizedType;

  orderTotalValue?: number;

  static toProps(order: OrderListWithBaseItem): OrderActionProps {
    return {
      orderId: order?.orderId,
      orderCode: order?.orderCode,
      brandId: order?.brandId,
      brandCommercialName: order?.brandCommercialName,
      brandCompanyName: order?.brandCompanyName,
      customerId: order?.customerId?.toString(),
      customerCommercialName: order?.customerCommercialName,
      customerCompanyName: order?.customerCompanyName,
      orderStatus: order?.orderStatus,
      orderSplitted: order?.orderSplitted,
      orderSyncStatus: order?.orderSynchronized,
      orderSplitSettings: order?.orderSplitSettings,
      orderTotalValue: order?.orderTotalValue,
    };
  }

  static orderToProps(order: Order | ListOrdersDTO): OrderActionProps {
    return {
      brandCommercialName: order?.brand?.commercialName,
      brandCompanyName: order?.brand?.companyName,
      brandId: order?.brand?.id,
      customerId: order?.customer?.id,
      customerCommercialName: order?.customer?.commercialName,
      customerCompanyName: order?.customer?.companyName,
      orderCode: order?.code,
      orderId: order?.id,
      orderSplitSettings: order?.splitSettings,
      orderSplitted: order?.splitted,
      orderStatus: order?.status as StatusType,
      orderSyncStatus: order?.synchronized,
      orderTotalValue: order?.totalValue,
    };
  }

  static FromReportSupplierOrder(
    order: ReportOrderSalesBySupplierType.OrderSale,
  ): OrderActionProps {
    return {
      orderId: order?.orderId,
      orderStatus: order?.status,
      orderCode: order?.orderCode,
    };
  }
}

export interface HandleOkResponseProps {
  action: ActionEnum;
  orderId: string;
}
